import { render, staticRenderFns } from "./VotesGrid.vue?vue&type=template&id=3dd28907"
import script from "./VotesGrid.vue?vue&type=script&lang=js"
export * from "./VotesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports